// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__49RUD","left":"styles_left__10dEV"};